import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Xaman's `return_url.web` lands here after a user signs in via the Xaman app.
// On mobile the "Open Xaman App" link uses target="_blank", so this typically
// renders in a new tab while the original tab's modal completes the login via
// polling. Try to close this tab; if the browser blocks window.close(), fall
// back to redirecting home so the user isn't stranded on a blank page.
export function AuthCallbackPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const closeTimer = setTimeout(() => {
      window.close();
    }, 600);

    const fallbackTimer = setTimeout(() => {
      navigate('/', { replace: true });
    }, 1500);

    return () => {
      clearTimeout(closeTimer);
      clearTimeout(fallbackTimer);
    };
  }, [navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-2 bg-default-background px-6 text-center">
      <div className="text-2xl font-bold text-default-font">Signed in!</div>
      <div className="text-sm text-subtext-color">
        You can close this tab and return to xrp.deals.
      </div>
    </div>
  );
}
